import { create } from 'zustand';
import type { TabType } from '../store/tabStore';

const readArticle = () => new URL(window.location.href).searchParams.get('help');
interface HelpState {
  articleId: string | null;
  query: string;
  panelOpen: boolean;
  originTab: TabType;
  openPanel: (originTab: TabType) => void;
  closePanel: () => void;
  selectArticle: (id: string | null, updateUrl?: boolean) => void;
  setQuery: (query: string) => void;
}

export const useHelpStore = create<HelpState>(set => ({
  articleId: readArticle(), query: '', panelOpen: false, originTab: 'landing',
  openPanel: originTab => set({ panelOpen: true, originTab, articleId: null, query: '' }),
  closePanel: () => set({ panelOpen: false }),
  selectArticle: (articleId, updateUrl = true) => {
    if (updateUrl) {
      const url = new URL(window.location.href);
      if (articleId) url.searchParams.set('help', articleId);
      else url.searchParams.delete('help');
      if (url.href !== window.location.href) window.history.pushState(null, '', url);
    }
    set({ articleId, query: '' });
  },
  setQuery: query => set({ query, articleId: null }),
}));

window.addEventListener('popstate', () => useHelpStore.setState({ articleId: readArticle(), query: '' }));
